try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Button } from '@design-system/button';
import { CheckboxField } from '@design-system/checkbox-field';
import { RTEText } from '@design-system/rte-text';
import { LdsContentFetchers } from '@phx-husky/fetch-lds';
import { LdsHyhoContentFetcher } from '@phx-husky/fetch-lds-hyho';
import { getQueries } from '@promo-platform/utils';
import classNames from 'classnames';
import { forwardRef, useState } from 'react';
import { useQueries } from 'react-query';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var LegalDocumentType;
(function (LegalDocumentType) {
    LegalDocumentType["Health"] = "Health";
    LegalDocumentType["OneTrust"] = "OneTrust";
})(LegalDocumentType || (LegalDocumentType = {}));

const HEALTH_DEFAULT_URL = 'https://digital-lds-application-web-production.frankfurt.rbdigitalcloud.com';
const OT_DEFAULT_URL = 'https://ot-proxy-api-cf6r4v.m3jzw3-2.deu-c1.cloudhub.io';
const HYHO_PREFIX = 'HYHO:';
const HYHO_DEFAULT_CONFIG = {
    bucketName: 'sk-lds-api',
    bucketLocation: 'eu-central-1',
    awsAccessKeyId: 'AKIAUKXFWT56A4NE3YDH',
    awsAccessKey: 'srcLRLjvK7UiwTnXAxXxirlNDjalzUXR5/e4Rirt',
};
const LegalField = forwardRef((_a, ref) => {
    var { description, config, showMoreText, showLessText, extendedDescription } = _a, rest = __rest(_a, ["description", "config", "showMoreText", "showLessText", "extendedDescription"]);
    const queries = getQueries(description);
    const [showExtendedDescription, setShowExtendedDescription] = useState(false);
    useQueries(queries.map((lds) => ({
        queryKey: [lds.data.legalDocumentId],
        queryFn: () => {
            if (rest.legalDocumentSourceType === LegalDocumentType.OneTrust) {
                return LdsContentFetchers.ot({
                    uri: lds.data.legalDocumentId,
                    config: {
                        otBaseUrl: (config === null || config === void 0 ? void 0 : config.oneTrustBaseUrl) || OT_DEFAULT_URL,
                    },
                });
            }
            if (lds.data.legalDocumentId.startsWith(HYHO_PREFIX))
                return LdsHyhoContentFetcher.hyho({
                    uri: lds.data.legalDocumentId.replace(HYHO_PREFIX, ''),
                    config: (config === null || config === void 0 ? void 0 : config.hyhoConfig) || HYHO_DEFAULT_CONFIG,
                });
            return LdsContentFetchers.health({
                uri: lds.data.legalDocumentId,
                config: {
                    healthBaseUrl: (config === null || config === void 0 ? void 0 : config.healthBaseUrl) || HEALTH_DEFAULT_URL,
                },
            });
        },
    })));
    return (jsxs(Fragment, { children: [jsx(CheckboxField, Object.assign({ ref: ref, description: description, className: "cds-legal-field" }, rest)), extendedDescription && showLessText && showMoreText ? (jsx(Button, Object.assign({ onClick: () => setShowExtendedDescription(!showExtendedDescription), className: classNames('cds-legal-field__button', {
                    'cds-legal-field__button-extended': showExtendedDescription,
                }) }, { children: showExtendedDescription ? showLessText : showMoreText }))) : null, extendedDescription && showExtendedDescription ? (jsx(RTEText, { text: extendedDescription, className: "cds-legal-field__rte-extend" })) : null] }));
});

export { LegalField };
